<template>
  <div class="collapsible" :class="{ open: isOpen, striped }">
    <div class="title" @click="isOpen = !isOpen">
      <div class="main">
        <div class="flex-grow" :class="{ 'flex items-center': $mq !== 'sm' }">
          <slot name="title" />
          <template v-if="$mq !== 'sm'">
            <slot name="subtitle" />
          </template>
        </div>
        <div class="icon-container">
          <i class="far fa-chevron-right fa-fw text-red" />
        </div>
      </div>
      <template v-if="$mq === 'sm'">
        <slot name="subtitle" />
      </template>
    </div>
    <div class="content" v-show="isOpen">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Collapsible",
  props: {
    striped: Boolean,
    initiallyOpen: Boolean
  },
  data() {
    return {
      isOpen: this.initiallyOpen
    };
  }
};
</script>

<style lang="scss" scoped>
.collapsible {
  &.striped {
    &:nth-child(odd) {
      .title {
        @apply bg-lightgray-lightest;
      }
    }

    &:nth-child(even) {
      .title {
        @apply bg-lightgray-lighter;
      }
    }

    &:not(.open) {
      & + .collapsible {
        &:not(.open) {
          .title {
            @apply border-t-0;
          }
        }
      }
    }
  }

  &.open {
    .title {
      .icon-container {
        i {
          transform: rotate(90deg);
        }
      }
    }
  }

  .title {
    @apply border-t border-b border-lightgray p-4 cursor-pointer;

    @screen md {
      @apply border-none;
    }

    .main {
      @apply flex justify-between;

      @screen md {
        @apply items-center;
      }

      .icon-container {
        i {
          transition: all 0.3s ease;
        }
      }
    }
  }
  .content {
    @apply bg-white;
  }
}
</style>
